import React, { useState } from 'react'
import Breadcrumb from '../Components/Breadcrumb'
import Pagehelmet from '../Components/Pagehelmet'
import Booking from '../Components/Booking'
import axios from 'axios'
import { useLocation, useParams, useNavigate } from 'react-router-dom';

const Booknow = () => {
   
  const location = useLocation();
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const { event, TicketType } = location.state || {};

  const totalAmount = TicketType?.price;
  const userData = JSON.parse(localStorage.getItem('User_Info')) || {};

  const {
    _id,
    email,
    firstName,
    lastName,
    phone,
    address,
    emergencyContact,
    preferences,
    familyMembers,
  } = userData  
console.log(userData,'userData')
  const [data, setData] = useState({
    user: _id,
    event: event.id,
    tickets: TicketType?.id,
    totalAmount: totalAmount,
    discount: "",
    billingAddress: ""
  });
  console.log(data, 'data')
  const headers = {
    Authorization: `Bearer ${process.env.REACT_APP_API_TOKEN}`,
  };

  const url = `${process.env.REACT_APP_API_URL}/orders/create`;
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    try {
      setLoading(true);
      const response = await axios.post(url, data, { headers });

      if (response.data) {
        setSuccess(true);
        // Redirect to success page or show message
        setTimeout(() => {
          navigate('/Checkout', {
            state: {  // Correct property name is 'state' not 'formData'
              event: event, 
              TicketType: TicketType // Include API response if needed
            }});
        }, 2000);
      }
    } catch (err) {
      console.error('Error submitting form:', err);
      setError(err.response?.data?.message || 'An error occurred during booking');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div>
      <Pagehelmet pageTitle="Book Ticket Now" />
      <Breadcrumb title="Book Tickets Now" />

      <section className="ticket-booking">
        <div className="container">
          <div className="booking-form w-lg-75 m-auto px-2">
            <div className="form-title mb-4">
              <h2 className="mb-2"><span className="pink">Event</span> Booking Form</h2>
              <p>Book your tickets to the event now!!</p>
            </div>
            <div className="form-content">
              {error && <div className="alert alert-danger">{error}</div>}
              {success && <div className="alert alert-success">Booking successful! Redirecting...</div>}

              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label className="form-label">Event</label>
                  <input
                    type="text"
                    className="form-control"
                    value={event?.name || ''}
                    readOnly
                  />
                </div>

  <div className="mb-3">
                  <label className="form-label">email</label>
                  <input
                    type="text"
                    className="form-control"
                    value={email|| ''}
                    readOnly
                  />
                </div>

  <div className="mb-3">
                  <label className="form-label">first Name</label>
                  <input
                    type="text"
                    className="form-control"
                    value={firstName|| ''}
                    readOnly
                  />
                </div>
                
  <div className="mb-3">
                  <label className="form-label">last Name</label>
                  <input
                    type="text"
                    className="form-control"
                    value={lastName|| ''}
                    readOnly
                  />
                </div>
                  <div className="mb-3">
                  <label className="form-label">phone</label>
                  <input
                    type="text"
                    className="form-control"
                    value={phone|| ''}
                    readOnly
                  />
                </div>

                       <div className="mb-3">
                  <label className="form-label">address</label>
                  <input
                    type="text"
                    className="form-control"
                    value={address|| ''}
                    readOnly
                  />
                </div>

                
                       <div className="mb-3">
                  <label className="form-label">family Members</label>
                  <input
                    type="text"
                    className="form-control"
                    value={familyMembers|| ''}
                    readOnly
                  />
                </div>
 












                <div className="mb-3">
                  <label className="form-label">Ticket Type</label>
                  <input
                    type="text"
                    className="form-control"
                    value={TicketType?.name || ''}
                    readOnly
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">Total Amount</label>
                  <input
                    type="text"
                    className="form-control"
                    value={`${totalAmount || '0'} ETB`}
                    readOnly
                  />
                </div>

                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={loading}
                >
                  {loading ? 'Processing...' : 'Confirm Booking'}
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default Booknow;